<template>
    <div class="modal" id="kaspi-qr-modal" role="dialog" aria-labelledby="kaspi-qr-modal-label" aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="row align-items-center justify-content-center w-100">
                        <div class="col-auto">
                            <h5 class="modal-title">
                                Оплата с Kaspi.kz
                            </h5>
                        </div>
                        <div class="col-auto">
                            <img src="/images/kaspi_logo_simple.svg" alt=""/>
                        </div>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="kaspiQRData && kaspiQRData.Data">
                    <div v-if="status != 'Error'">
                        <div class="text-center mt-sm-3 mt-3 mb-3">
                            <img src="/images/kaspi_qr_scan.svg" alt="kaspi" class="mx-auto"/>
                        </div>
                        <div class="kaspi-price">{{ order.price | formatNumber }} ₸</div>
<!--                        <div class="text-center qr-wrapper mt-3">-->
<!--                            <qr-code :text="kaspiQRData.Data.PaymentLink"></qr-code>-->
<!--                        </div>-->
                        <div class="text-center qr-wrapper mt-0">
                            <vue-qr logoSrc="/images/kaspi_qr_inside2.svg"
                                    :text="kaspiQRData.Data.PaymentLink"
                                    :size="280">
                            </vue-qr>
                        </div>

                        <div class="text-center kaspi-pay-type">
                            <div>Способ оплаты</div>
                            <div>
                                <img src="/images/kaspi_gold.svg" alt="kaspi gold"/>
                            </div>
                        </div>

                        <div class="mt-3 text-center use-link-text">
                            или воспользуйтесь <a class="kaspi-link" :href="kaspiQRData.Data.PaymentLink" target="_blank">ссылкой</a>
                        </div>

                        <div class="text-right mt-3">
                            <div class="d-inline-block text-muted ml-auto">
                                <span>Ссылка активна: </span>
                                <span v-if="checkouttime > 0">{{ minutes }}:{{ seconds }}</span>
                                <span v-if="checkouttime <= 0">истекла</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="status == 'Error'" class="alert alert-danger mt-3">Произошла ошибка оплаты</div>
                    <div v-if="status == 'Wait'" class="alert alert-info mt-3">Оплата в процессе</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"
import {mapState} from "vuex"

export default {
    name: "KaspiQR",
    props: {
        kaspiQRData: { type: Object, default: null },
        redirectUrl: { type: String },
    },
    computed: {
        minutes () {
            return String(Math.floor(this.checkouttime / 60)).padStart(2, '0')
        },
        seconds () {
            return String(this.checkouttime % 60).padStart(2, '0')
        },
        ...mapState(['order']),
    },
    data() {
        return {
            status: null,
            statusTimer: null,
            qrActiveTimer: null,
            checkouttime: 0,
            end: null
        }
    },
    methods: {
        checkQRStatus() {
            axios.get(`/api/kaspi/status/${this.kaspiQRData.Data.PaymentId}`).then(res => {
                this.status = (res.data && res.data.Data && res.data.Data.Status) ? res.data.Data.Status : null
                if(this.status == 'Processed') {
                    window.location = this.redirectUrl
                }
            });
        },
        countdown() {
            if(!this.kaspiQRData) return
            let now = moment(new Date())
            // let end = moment(this.kaspiQRData.Data.ExpireDate)
            if(!this.end) {
                this.end = moment(new Date()).add(this.kaspiQRData.Data.PaymentBehaviorOptions.LinkActivationWaitTimeout, 'seconds')
            }
            this.checkouttime = Math.round(moment.duration(this.end.diff(now)).asSeconds())
            if(this.checkouttime <= 0 && this.qrActiveTimer) {
                clearInterval(this.qrActiveTimer)
            }
        }
    },
    mounted() {
        $('#kaspi-qr-modal').on('shown.bs.modal', () => {
            if(this.statusTimer) clearInterval(this.statusTimer)
            if(this.kaspiQRData && this.kaspiQRData.Data) {
                this.statusTimer = setInterval(() => {
                    this.checkQRStatus()
                }, (this.kaspiQRData.Data.PaymentBehaviorOptions.StatusPollingInterval * 1000))
                this.countdown()
                this.qrActiveTimer = setInterval(this.countdown, 1000)
            }
        }).on('hidden.bs.modal', () => {
            if(this.statusTimer) clearInterval(this.statusTimer)
            if(this.qrActiveTimer) clearInterval(this.qrActiveTimer)
            this.status = null
            this.end = null
        })
    }

}
</script>

<style scoped>
.modal-title {
    font-size: 30px;
    font-weight: 900;
}
.qr-wrapper /deep/ img {
    margin: 0 auto;
}
.use-link-text {
    font-size: 18px;
}
.kaspi-link {
    color: #F14635 !important;
}
.modal-content .close {
    position: absolute;
    right: 15px;
    top: 15px;
}
.kaspi-price {
    text-align: center;
    font-weight: 700;
    font-size: 32px;
}
.kaspi-pay-type {
    font-size: 18px;
}
.kaspi-pay-type img {
    margin-top: 8px;
}

@media only screen and (max-width: 768px) {
    .modal-title {
        font-size: 24px;
    }
}
</style>
